import { render, staticRenderFns } from "./DiscoverBiblioteca.vue?vue&type=template&id=e465763a&scoped=true"
import script from "./DiscoverBiblioteca.vue?vue&type=script&lang=js"
export * from "./DiscoverBiblioteca.vue?vue&type=script&lang=js"
import style0 from "./DiscoverBiblioteca.vue?vue&type=style&index=0&id=e465763a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e465763a",
  null
  
)

export default component.exports